import React from "react";
import { ConfigProvider } from "antd";
import { DatePicker } from "antd";
import { DateField } from "../CustomFields";
import { useReportMonk } from "../../context/reportMonk";
import {
  SelectLabel,
  SelectContainer,
  TotalScoreContainer,
} from "./shareStyledComponents";

import moment from "moment";
import "moment/locale/th";
import "moment-timezone";
import locale from "antd/lib/locale/th_TH";
import DayResult from "./DayResult";
import DayTotalScore from "./DayTotalScore";
moment.locale("th");
moment.tz("Asia/Bangkok");
const dateFormat = (value) => {
  //return moment(value).add(543, "year").format("DD/MM/YYYY");
  return moment(value).format("DD/MM/YYYY");
};

const DayTabResult = () => {
  const {
    getEnableDates,
    onChangeSelectDate,
    getCurrentDateInMoment,
    isSelectedDate,
  } = useReportMonk();

  const disabledDate = (currentDate) => {
    if (!currentDate) return true;
    const enableDates = getEnableDates();
    const mCurrentDate = moment(currentDate).format("YYYY-MM-DD");
    for (let i = 0; i < enableDates.length; ++i) {
      if (mCurrentDate === moment(enableDates[i]).format("YYYY-MM-DD"))
        return false;
    }
    return true;
  };

  return (
    <SelectContainer>
      <SelectLabel>ผลของวันที่</SelectLabel>
      <br />
      <ConfigProvider locale={locale}>
        <DateField>
          <DatePicker
            disabled={!getEnableDates().length}
            onChange={onChangeSelectDate}
            disabledDate={disabledDate}
            format={dateFormat}
            defaultValue={getCurrentDateInMoment()}
          />
        </DateField>
      </ConfigProvider>

      {isSelectedDate() && (
        <>
          <TotalScoreContainer>
            <DayTotalScore />
          </TotalScoreContainer>
          <DayResult />
        </>
      )}
    </SelectContainer>
  );
};

export default DayTabResult;
